import { FC } from 'react';

import { FormTabs } from 'components';
import { Stack } from 'libs/ui';
import { ClientMainInfo } from 'modules/client/common/components/ClientMainInfo';
import {
  CountryRiskProvider,
  CountryRiskRole,
} from 'modules/client/common/feature';

import { LegalClientHeadSectionsProps } from './types';
import { useLegalClientHeadSections } from './useLegalClientHeadSections';

export const LegalClientHeadSections: FC<LegalClientHeadSectionsProps> = ({
  countryRiskAt,
  ...props
}) => {
  const { tabs, info } = useLegalClientHeadSections(props);

  return (
    <CountryRiskProvider
      at={countryRiskAt}
      role={CountryRiskRole.LegalClientHead}
    >
      <Stack spacing={36}>
        {info && <ClientMainInfo info={info} />}
        <FormTabs tabs={tabs} />
      </Stack>
    </CountryRiskProvider>
  );
};
